module.exports = " <cpheader></cpheader> <cpconteudo></cpconteudo> <cprodape></cprodape> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 11
// module chunks = 0